import { render, staticRenderFns } from "./EntityDictionary.vue?vue&type=template&id=b495b724"
import script from "./EntityDictionary.vue?vue&type=script&lang=js"
export * from "./EntityDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports